module.exports = __webpack_public_path__ + "img/5.e9d8f6a8.webp";